export default __webpack_public_path__ + "static/hmeisler-57f45dd6b4699af7ea42b83dee69159a.jpg";